import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import {LuClipboardList} from "react-icons/lu";
import {BsChevronLeft, BsShop} from "react-icons/bs";
import {FaCubes} from "react-icons/fa";
import {TbDoorExit, TbReportAnalytics} from "react-icons/tb";
import EmptyPic from "../../Assets/Images/emptypic.png";
import {useNavigate} from "react-router-dom";
import {GiHamburgerMenu} from "react-icons/gi";
import LogoPic from "../../Assets/Images/logo.png";
import {BiSolidSelectMultiple} from "react-icons/bi";
import {LiaUserEditSolid} from "react-icons/lia";

function EditProfile() {
    const navigate = useNavigate();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [user, setUser] = React.useState([]);
    const [orderCount, setOrderCount] = React.useState([]);
    const [avatar, setAvatar] = React.useState('');
    const [surname, setSurname] = React.useState('');
    const [name, setName] = React.useState('');
    const [nationalCode, setNationalCode] = React.useState('');
    // const [tel, setTel] = React.useState('');
    // const [email, setEmail] = React.useState('');
    const [username, setUsername] = React.useState('');
    const [file, setFile] = React.useState(null);
    // const [description, setDescription] = React.useState('');
    const [pic, setPic] = React.useState(EmptyPic);


    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if (!token) {
            window.location.replace('/login')
        }

        API.getUserInfo()
            .then((response) => {

                  setUser(response.data.user);
                for(let v in response.data.user.vendor) {
                    if(response.data.user.vendor[v].id === parseInt(window.localStorage.getItem("vendor"))) {
                        setOrderCount(response.data.user.vendor[v].ordersCount)
                    }
                }
                setAvatar(response.data.user.avatar)
                setName(response.data.user.name)
                setSurname(response.data.user.surname)
                setUsername(response.data.user.username)
                setNationalCode(response.data.user.national_code)
                setIsLoaded(true)
            })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });



    }, []);

    const onExitClick = () => {
        localStorage.clear();
        document.cookie = "auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.replace("/")
    }

    const onFileChange = (event) => {
        let reader = new FileReader()
        reader.readAsDataURL(event.target.files[0])
        reader.onload = () => {
            setPic(reader.result)
            setFile(event.target.files[0])
        };

    }



    const onButtonClick = () => {

        const formData = new FormData();

        if (file)
            formData.append('avatar', file);
        formData.append('surname', surname);
        formData.append('name', name ? name : '' );
        formData.append('national_code', nationalCode);

        formData.append('device_info', navigator.userAgent);

        setIsLoaded(false)
        API.updateProfile(formData)
            .then((response) => {
                toast.success(response.message);
                setIsLoaded(true)
            })
            .catch((error) => {

                toast.error(error.response.data.user_message);

            });
    }
    
    return (
        <React.Fragment>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }

            <section className="container-fluid  rtl">
                <div className="row bg-primary-color py-3 ps-0" id='menu-button'>
                    <div className="col-6 text-end "
                         onClick={() => {
                             window.document.getElementById('side-menu').style.display = 'block';
                         }}
                    >
                        <GiHamburgerMenu className='text-white fw-bold text-big-3'/>

                    </div>
                    <div className="col-6 text-start">
                        <img src={LogoPic} alt="پخش من" className="rounded " width='30'/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3 p-5 ">
                        <div className="row " id='side-menu'>
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-12 text-center">
                                                 {
                                            isLoaded && user?.vendor?.map (vendor  => {
                                                if(vendor.id === parseInt(window.localStorage.getItem("vendor")) ) {
                                                    return (
                                                        <img src={vendor.cover_photo} alt="Cover" className='w-100 mt-3 company-cover-photo' />
                                                    )
                                                }
                                                return '';
                                            } )
                                        }
                                        <div className='text-primary-color mb-4 text-small-2 mt-3'>
                                            {user.name}
                                            &nbsp;

                                            {user.surname}
                                            &nbsp;

                                            (
                                            {
                                                window.localStorage.getItem("vendorTitle")
                                            }
                                            )

                                        </div>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/home/1`)}
                                    >
                                        <LuClipboardList className='mx-2'/>
                                                    سفارش های تازه ثبت شده
                                        {
                                            orderCount > 0 &&  <span className='badge badge-pill badge-primary bg-danger mx-2 text-small-3 '>
                                                                    {orderCount}
                                                                </span>
                                        }
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/home/2`)}
                                    >
                                        <LuClipboardList className='mx-2'/>
                                        سفارش های جاری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/home/3`)}
                                    >
                                        <LuClipboardList className='mx-2'/>
                                        سفارش های تمام شده
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>

                                    <div className="col-12 item "
                                         onClick={() => navigate(`/products`)}
                                    >
                                        <FaCubes className='mx-2'/>
                                        مدیریت کالاها
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/vendor/manage`)}
                                    >
                                        <BsShop className='mx-2'/>
                                        مدیریت اطلاعات مجموعه
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/vendor/select`)}

                                    >
                                        <BiSolidSelectMultiple className='mx-2'/>
                                        انتخاب مجموعه فعال
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>


                                    <div className="col-12 item "
                                         id='active'
                                         onClick={() => navigate(`/edit-profile`)}
                                    >
                                        <LiaUserEditSolid className='mx-2'/>
                                        ویرایش حساب کاربری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={() => navigate(`/reports`)}
                                    >
                                        <TbReportAnalytics className='mx-2'/>
                                        گزارش فاکتورهای فروش
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                    <div className="col-12 item "
                                         onClick={onExitClick}
                                    >
                                        <TbDoorExit className='mx-2'/>
                                        خروج از حساب کاربری
                                        <BsChevronLeft className='float-start mt-1'/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-9 pt-md-5 pb-5 ">

                        <div className="row main-part mx-2">
                            <div className="col-12 page-title text-center pb-4 mb-5 border-bottom fw-bold text-muted">
                            ویرایش حساب کاربری

                            </div>
                            <div className="col-12 ">

                                <img alt="Avatar"
                                     src={(avatar && !file) ? avatar : pic }
                                     width={64} className='rounded-circle'/>
                                <span className="px-5">
                                                <label className="custom-file-upload float-left mt-3">
                                                    انتخاب تصویر پروفایل جدید
                                                 <input type="file" onChange={onFileChange}/>
                                                </label>
                                            </span>
                            </div>

                            <div className="form-floating col-md-6 mt-4">
                                <input type="text"
                                       className="form-control px-5"
                                       id="name" name="name"
                                       placeholder="نام"
                                       value={name}
                                       onChange={(event) => {
                                           setName(event.target.value)
                                       } }
                                />
                                <label htmlFor="name" className="right-0">نام</label>
                            </div>
                            <div className="form-floating col-md-6 mt-4">
                                <input type="text"
                                       className="form-control px-5"
                                       id="surname" name="surname"
                                       placeholder="نام خانوادگی"
                                       value={surname}
                                       onChange={(event) => {
                                           setSurname(event.target.value)
                                       } }
                                />
                                <label htmlFor="surname" className="right-0">نام خانوادگی</label>
                            </div>
                            <div className="form-floating col-md-6 mt-4">
                                <input type="text"
                                       className="form-control px-5 text-left"
                                       id="username" name="username"
                                       placeholder="شماره موبایل"
                                       value={username.replace('+98','0')}
                                       disabled
                                />
                                <label htmlFor="mobile" className="right-0">شماره موبایل</label>
                            </div>
                            <div className="form-floating col-md-6 mt-4">
                                <input type="text"
                                       className="form-control px-5"
                                       id="nationalCode" name="nationalCode"
                                       placeholder="کد ملی"
                                       value={nationalCode ? nationalCode : ''}
                                       onChange={(event) => {
                                           setNationalCode(event.target.value)
                                       } }
                                />
                                <label htmlFor="nationalCode" className="right-0">کد ملی</label>
                            </div>

                   {/*         <div className="form-floating col-md-6 mt-4">
                                <input type="email"
                                       className="form-control px-5"
                                       id="email" name="email"
                                       placeholder="آدرس ایمیل"
                                       value={email ? email : ''}
                                       onChange={onInputChange}
                                />
                                <label htmlFor="email" className="right-0">آدرس ایمیل</label>
                            </div>
                            <div className="form-floating col-md-6 mt-4">
                                <input type="tel"
                                       className="form-control px-5"
                                       id="tel" name="tel"
                                       placeholder="شماره تماس ثابت"
                                       value={tel ? tel : ''}
                                       onChange={onInputChange}
                                />
                                <label htmlFor="tel" className="right-0">شماره تماس ثابت</label>
                            </div>*/}


                            <div className="col-12 p-2 fixed-bottom max-w-lg">
                                <button
                                    className="btn btn-primary text-center bg-secondary-color text-semi-big w-100 p-2 pr-4"
                                    onClick={onButtonClick}
                                    disabled={!isLoaded}
                                >
ویرایش اطلاعات



                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}

export default EditProfile;